
import { mapGetters } from "vuex";
import http from "../../service/data-service";

export default {
    state: {
      padroes: null,
    },
    getters: {
      padroes(state: any) {
        return state.padroes;
      },
    },
    mutations: {
      setPadroes(state: any, padroes: any) {
        state.padroes = padroes;
      },
    },
    actions: {
      fetchPadroes({ commit }: { commit: any }) {
        console.log('');
        return new Promise((resolve, reject) => {
          http
            .get("/api/v1/padroes/" )
            .then((result: any) => {
              commit("setPadroes", result.data);
              resolve(result.data);
            })
            .catch((err: any) => {
              commit("setError", err.response || err);
              try {
                reject(err.response.data.error);
              } catch (e) {
                reject(err);
              }
            });
        });
      },
      savePadroes({ commit, state }: { commit: any, state : any }, payload:any) {
        return new Promise((resolve, reject) => {
          http
            .post("/api/v1/padroes/", payload )
            .then((result: any) => {
              state.padroes.push( result.data);
              resolve(state.padroes);
            })
            .catch((err: any) => {
              commit("setError", err.response || err);
              try {
                reject(err.response.data.error);
              } catch (e) {
                reject(err);
              }
            });
        });
      },
    },
  };
  